import React from 'react';

// export function SidebarSection({ title, children }) {
//   return (
//     <div className="mb-4">
//       <h3 className="font-medium text-787878 px-4 mb-2">{title}</h3>
//       <ul className="space-y-1">
//         {children}
//       </ul>
//     </div>
//   );
// }

export function SidebarSection({ title, children }) {
  return (
    <div className="mb-6">
      {title && (
        <h3 className="px-30 mx-2.5 mb-3 text-xs font-semibold tracking-wider text-787878">
          {title}
        </h3>
      )}
      <ul className="space-y-1">
        {children}
      </ul>
    </div>
  );
}